<script>
  import CustomerStatusMixin from './CustomerStatusMixin.vue';
  import SwalModalMixin from './SwalModalMixin.vue';

  export default {
    name: 'get-hypefury-subscription-mixin',
    methods: {
      displayGetHypefurySubscriptionPopUp(title, feature) {
        this.swalModal({
          title,
          html: `The ability to ${feature} is one of the many
            perks of being an Aerielab ${this.getPlanLabel('standard')} subscriber.<br>
            Do you want to get an Aerielab subscription now
            and benefit from a bunch of other possibilities to grow your account?`,
          type: 'info',
          confirmButtonText: `Yes, I want to get a ${this.getPlanLabel(
            'standard'
          )} Aerielab subscription!`,
          cancelButtonText: 'No, thanks',
          showCancelButton: true,
          allowOutsideClick: false,
          onClose: this.close,
          preConfirm: () => {
            this.$router.push('/billing');
            return true;
          },
        });
      },
    },
    mixins: [SwalModalMixin, CustomerStatusMixin],
  };
</script>
